import { render, staticRenderFns } from "./PointDebt.vue?vue&type=template&id=586b0e5e&"
import script from "./PointDebt.vue?vue&type=script&lang=js&"
export * from "./PointDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports